import { Injectable } from '@angular/core';
import { ProductCategoryNames } from 'src/app/models/case';
import { BaseProductService } from '../+products/-base-product.service';
import { CommunityProgramsService } from '../+products/community/community-programs.service';
import { LISService } from '../+products/lis/lis.service';
import { MedicaidService } from '../+products/medicaid/medicaid.service';
import { SNAPService } from '../+products/snap/snap.service';
import { SSIService } from '../+products/ssi/ssi.service';
import { VeteranService } from '../+products/veteran/veteran.service';
import { BaseProductStateModel } from './../+products/base-product-state.models';
import { InjectorInstance } from './global.service';
import { IServiceFactoryService } from './service-factory.models';

@Injectable({
    providedIn: 'root'
})
export class ServiceFactoryService implements IServiceFactoryService {


    getProductService(productName: string): BaseProductService<BaseProductStateModel> {
        if (!productName) {
            return;
        }

        switch (productName.toUpperCase()) {
            case ProductCategoryNames.Community.toUpperCase():
                return InjectorInstance.get(CommunityProgramsService);
                break;
            case ProductCategoryNames.Medicaid.toUpperCase():
                return InjectorInstance.get(MedicaidService);
                break;
            case ProductCategoryNames.SNAP.toUpperCase():
                return InjectorInstance.get(SNAPService);
                break;
            case ProductCategoryNames.LIS.toUpperCase():
                return InjectorInstance.get(LISService);
                break;
            case ProductCategoryNames.VA.toUpperCase():
                return InjectorInstance.get(VeteranService);
                break;
            case ProductCategoryNames.SSI.toUpperCase():
                return InjectorInstance.get(SSIService);
                break;
            default:
                return null;
        }
    }
}
